import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import './Testimonials.css';

const Testimonials = () => {
    const { t } = useTranslation();
    const [currentIndex, setCurrentIndex] = useState(0);

    const reviews = ['review1', 'review2', 'review3'];

    const nextReview = () => {
        setCurrentIndex((prev) => (prev + 1) % reviews.length);
    };

    const prevReview = () => {
        setCurrentIndex((prev) => (prev - 1 + reviews.length) % reviews.length);
    };

    return (
        <section id="testimonials" className="section testimonials-section">
            <div className="container">
                {/* Header */}
                <motion.div
                    className="section-header"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                >
                    <h2 className="section-title">{t('testimonials.title')}</h2>
                    <p className="section-subtitle">{t('testimonials.subtitle')}</p>
                </motion.div>

                {/* Testimonials Carousel */}
                <div className="testimonials-carousel">
                    <button className="carousel-btn prev" onClick={prevReview} aria-label="Previous">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>

                    <div className="carousel-content">
                        <AnimatePresence mode="wait">
                            <motion.div
                                key={currentIndex}
                                className="testimonial-card"
                                initial={{ opacity: 0, x: 50 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: -50 }}
                                transition={{ duration: 0.3 }}
                            >
                                <div className="testimonial-quote">"</div>
                                <p className="testimonial-text">
                                    {t(`testimonials.reviews.${reviews[currentIndex]}.text`)}
                                </p>
                                <div className="testimonial-author">
                                    <div className="author-avatar">
                                        {t(`testimonials.reviews.${reviews[currentIndex]}.name`).charAt(0)}
                                    </div>
                                    <div className="author-info">
                                        <h3 className="author-name">
                                            {t(`testimonials.reviews.${reviews[currentIndex]}.name`)}
                                        </h3>
                                        <p className="author-role">
                                            {t(`testimonials.reviews.${reviews[currentIndex]}.role`)}
                                        </p>
                                    </div>
                                </div>
                                <div className="testimonial-rating">
                                    {'★'.repeat(5)}
                                </div>
                            </motion.div>
                        </AnimatePresence>
                    </div>

                    <button className="carousel-btn next" onClick={nextReview} aria-label="Next">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                </div>

                {/* Dots */}
                <div className="carousel-dots">
                    {reviews.map((_, index) => (
                        <button
                            key={index}
                            className={`dot ${index === currentIndex ? 'active' : ''}`}
                            onClick={() => setCurrentIndex(index)}
                            aria-label={`Go to review ${index + 1}`}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
